<template>
  <v-dialog :value="value" persistent scrollable max-width="600">
    <v-card>
      <v-card-title primary-title>
        <h3 class="primary--text">
          {{ $t('Create payment request on Conversion Value of Purchase') }}
        </h3>
        <span class="caption">
          {{
            $t(
              'This payment information will be displayed in the Conversion Value of Purchase section of your Facebook page.'
            )
          }}
        </span>
      </v-card-title>
      <v-card-text style="max-height: 600px">
        <v-layout row wrap>
          <v-flex xs6 pa-1>
            <div class="primary--text caption mb-1">{{ $t('event') }}</div>
            <v-select
              v-model="eventName"
              v-validate="'required'"
              name="eventName"
              :items="eventNames"
              item-text="label"
              item-value="value"
              :data-vv-as="$t('event')"
              hide-details
              outline
              single-line
              @change="(value) => (eventName = value)"
            />
            <span v-if="errors.has('eventName')" class="red--text" style="font-size: 0.9em">{{
              errors.first('eventName')
            }}</span>
          </v-flex>
          <v-flex xs6 pa-1 />
          <v-flex xs6 pa-1>
            <div class="form-control" style="width: 100%">
              <div class="primary--text caption">{{ $t('Amount') }}</div>
              <input
                ref="amount"
                v-model="amount"
                v-validate="'required|min_value:0'"
                name="eventSettingValue"
                type="text"
                class="form-control"
                :data-vv-as="$t('Amount')"
              />
              <span
                v-if="errors.has('eventSettingValue')"
                class="red--text"
                style="font-size: 0.9em"
                >{{ errors.first('eventSettingValue') }}</span
              >
            </div>
          </v-flex>
          <v-flex xs6 pa-1>
            <div>
              <div class="primary--text caption">{{ $t('monetary_unit') }}</div>
              <!-- TODO Add *  when event name is Purchase -->
              <v-autocomplete
                v-model="currency"
                v-validate="'required'"
                name="currencies"
                :items="$store.state.currencies"
                :data-vv-as="$t('monetary_unit')"
                hide-details
                outline
                single-line
              />
              <span v-if="errors.has('currencies')" class="red--text" style="font-size: 0.9em">{{
                errors.first('currencies')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" outline @click="onClose()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="onSave()">
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import conversionApi from '@/api/conversion'

export default {
  props: ['value', 'userId'],
  data() {
    return {
      eventNames: [
        {
          label: 'View Content',
          value: 'ViewContent'
        },
        {
          label: 'Add to Cart',
          value: 'AddToCart'
        },
        {
          label: 'Purchase',
          value: 'Purchase'
        },
        {
          label: 'LeadSubmitted',
          value: 'LeadSubmitted'
        }
      ],
      eventName: 'Purchase',
      amount: '',
      currency: 'THB'
    }
  },
  created() {
    this.currency = this.defaultCurrency
  },
  methods: {
    onClose() {
      this.$validator.reset()
      this.$emit('input', false)
      // this.eventName = ''
      this.amount = ''
      this.currency = this.defaultCurrency
    },
    async onSave() {
      const isValid = await this.$validator.validate()

      if (isValid) {
        const pageID = this.livechat.pageid

        try {
          this.$store.dispatch('loading')

          const event = {
            event_name: this.eventName,
            value: Number(this.amount),
            currency: this.currency
          }

          await conversionApi.postUserEvent({
            page_id: pageID,
            user_id: this.userId,
            is_save_chat_log: true,
            ...event
          })

          const message = {
            id: new Date().getTime(),
            messagedata: JSON.stringify(event),
            messagetype: 'save_user_event',
            userid: this.userId,
            pageid: pageID,
            answerby: 'bot',
            timestamp: new Date(),
            intent: '{save_user_event}',
            questiondata: '',
            questiontype: '',
            error_data: null,
            message_id: null,
            profile_pic: null,
            first_name: null
          }

          this.$emit('onSave', message)
          this.onClose()
        } finally {
          this.$store.dispatch('loading')
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      livechat: 'livechat'
    }),
    defaultCurrency() {
      if (this.livechat.bot && this.livechat.bot.ticket_v3_config) {
        return this.livechat.bot.ticket_v3_config.default_currency
      }

      return 'THB'
    }
  }
}
</script>

<style scoped>
.v-card__title {
  font-size: 18px;
}

.v-card__actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/FBConversionDialog.vue